import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconEdgeLeft12 from './IconEdgeLeft12';
import IconEdgeLeft16 from './IconEdgeLeft16';
import IconEdgeLeft20 from './IconEdgeLeft20';
import IconEdgeLeft24 from './IconEdgeLeft24';
import IconEdgeLeft32 from './IconEdgeLeft32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconEdgeLeft = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconEdgeLeft12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconEdgeLeft16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconEdgeLeft20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconEdgeLeft24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconEdgeLeft32 {...props} />}
        </span>
    );
};
IconEdgeLeft.displayName = 'FondueIconEdgeLeft';

export default memo(IconEdgeLeft);
